import {Trans, useTranslation} from 'react-i18next';
import {AlertBox} from '@chekin/guestapp-ui-kit';
import {useIVOnProperty} from 'hooks/useIVOnProperty';

function IVOnPropertyAlertBoxes() {
  const {t} = useTranslation('identity-verification');
  const {isIVOnPropertyUnavailable} = useIVOnProperty();
  const alertMessage = isIVOnPropertyUnavailable
    ? t('when_you_arrive_scan_qr_code_at_entrance_to_complete_iv')
    : t('identity_verification_process_now_available_scan_qr_code_at_property');

  return <AlertBox text={<Trans i18nKey={alertMessage} />} />;
}

export {IVOnPropertyAlertBoxes};
